import React from "react";
import { motion } from "framer-motion";

const easeOut = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: easeOut }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const StaggerGroup = ({ children, className = "", stagger = 0.12 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: stagger } },
    }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 40 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: easeOut } },
    }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for headings
export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          style={{ display: "block" }}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: delay + i * 0.12, ease: [0.76, 0, 0.24, 1] }}
          className={lineClassName}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
